// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1BPSm","top":"styles_top__2QYyz","left":"styles_left__3QAcK","description":"styles_description__3W6pS"};